import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const BRAND_GREEN = [29, 158, 117];
const BRAND_BLUE = [55, 138, 221];
const BRAND_GREEN_LIGHT = [240, 248, 244];
const dateStr = () => new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

function addHeader(doc, title, subtitle) {
  doc.setFillColor(...BRAND_GREEN);
  doc.rect(0, 0, 210, 36, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(15); doc.setFont('helvetica', 'bold');
  doc.text('SRG Real Estate Pvt. Ltd. — Jaipur', 14, 13);
  doc.setFontSize(10); doc.setFont('helvetica', 'normal');
  doc.text(title, 14, 21);
  doc.text('Date: ' + dateStr(), 14, 28);
  doc.setFontSize(8.5);
  doc.text(subtitle, 14, 34.5);
  doc.setTextColor(0, 0, 0);
}

export function generateProjectPDF(project, plots) {
  const doc = new jsPDF();
  addHeader(
    doc,
    `Project: ${project.name} | ${project.type} | Contact: ${project.contact}`,
    'Office: Gangaram Tower, Muhana Mandi Road Keshyawala, Gate No-1, Sanganer, Jaipur 302029'
  );

  const available = plots.filter(p => p.status === 'available');
  const booked = plots.filter(p => p.status === 'booked');
  const hold = plots.filter(p => p.status === 'hold');
  const nfs = plots.filter(p => p.status === 'nfs');

  doc.setFillColor(...BRAND_GREEN_LIGHT);
  doc.rect(0, 36, 210, 12, 'F');
  doc.setTextColor(15, 110, 86);
  doc.setFontSize(9.5); doc.setFont('helvetica', 'bold');
  doc.text(
    `Total: ${plots.length}   |   Available: ${available.length}   |   Booked: ${booked.length}   |   Hold: ${hold.length}   |   NFS: ${nfs.length}`,
    14, 44
  );

  let curY = 54;

  if (available.length > 0) {
    doc.setFontSize(10); doc.setTextColor(...BRAND_BLUE); doc.setFont('helvetica', 'bold');
    doc.text(`Available Plots (${available.length})`, 14, curY);
    autoTable(doc, {
      head: [['#', 'Plot No.', 'Facing', 'Size', 'Status']],
      body: available.map((pl, i) => [i + 1, pl.plot_no, pl.facing || '—', pl.size || '—', 'Available']),
      startY: curY + 3,
      styles: { fontSize: 8.5, cellPadding: 2.5 },
      headStyles: { fillColor: BRAND_BLUE, textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [230, 241, 251] },
    });
    curY = doc.lastAutoTable.finalY + 10;
  }

  if (booked.length > 0) {
    if (curY > 240) { doc.addPage(); curY = 15; }
    doc.setFontSize(10); doc.setTextColor(...BRAND_GREEN); doc.setFont('helvetica', 'bold');
    doc.text(`Booked Plots (${booked.length})`, 14, curY);
    autoTable(doc, {
      head: [['#', 'Plot No.', 'Facing', 'Size', 'Customer']],
      body: booked.map((pl, i) => [i + 1, pl.plot_no, pl.facing || '—', pl.size || '—', pl.booked_by || '—']),
      startY: curY + 3,
      styles: { fontSize: 8.5, cellPadding: 2.5 },
      headStyles: { fillColor: BRAND_GREEN, textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: BRAND_GREEN_LIGHT },
    });
    curY = doc.lastAutoTable.finalY + 8;
  }

  if (hold.length > 0) {
    if (curY > 240) { doc.addPage(); curY = 15; }
    doc.setFontSize(10); doc.setTextColor(239, 159, 39); doc.setFont('helvetica', 'bold');
    doc.text(`On Hold (${hold.length})`, 14, curY);
    autoTable(doc, {
      head: [['#', 'Plot No.', 'Facing', 'Size', 'Hold Until']],
      body: hold.map((pl, i) => [
        i + 1, pl.plot_no, pl.facing || '—', pl.size || '—',
        pl.hold_until ? new Date(pl.hold_until).toLocaleDateString('en-IN') : '—'
      ]),
      startY: curY + 3,
      styles: { fontSize: 8.5, cellPadding: 2.5 },
      headStyles: { fillColor: [239, 159, 39], textColor: 255, fontStyle: 'bold' },
    });
  }

  doc.setFontSize(7.5); doc.setTextColor(160, 160, 160); doc.setFont('helvetica', 'normal');
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`SRG Real Estate Pvt. Ltd. | ${project.contact} | Generated: ${dateStr()} | Page ${i}/${pageCount}`, 14, 290);
  }

  doc.save(`SRG_${project.name.replace(/ /g, '_')}_${dateStr().replace(/ /g, '-')}.pdf`);
}

export function generateAllProjectsPDF(projects) {
  const doc = new jsPDF();
  addHeader(doc, 'All Projects — Complete Inventory', 'Office: Gangaram Tower, Muhana Mandi Road Keshyawala, Gate No-1, Sanganer, Jaipur 302029');

  const grand = projects.reduce((a, p) => ({
    total: a.total + parseInt(p.total || 0),
    available: a.available + parseInt(p.available || 0),
    booked: a.booked + parseInt(p.booked || 0),
    nfs: a.nfs + parseInt(p.nfs || 0),
  }), { total: 0, available: 0, booked: 0, nfs: 0 });

  doc.setFillColor(...BRAND_GREEN_LIGHT);
  doc.rect(0, 36, 210, 12, 'F');
  doc.setTextColor(15, 110, 86);
  doc.setFontSize(9.5); doc.setFont('helvetica', 'bold');
  doc.text(
    `Grand Total: ${grand.total}  |  Available: ${grand.available}  |  Booked: ${grand.booked}  |  Not For Sale: ${grand.nfs}`,
    14, 44
  );

  autoTable(doc, {
    head: [['Project', 'Type', 'Total', 'Available', 'Booked', 'NFS', '% Booked']],
    body: projects.map(p => [
      p.name, p.type, p.total, p.available, p.booked, p.nfs || 0,
      p.total > 0 ? Math.round((p.booked / p.total) * 100) + '%' : '0%'
    ]),
    startY: 52,
    styles: { fontSize: 8.5, cellPadding: 2.5 },
    headStyles: { fillColor: BRAND_GREEN, textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: BRAND_GREEN_LIGHT },
  });

  doc.setFontSize(7.5); doc.setTextColor(160, 160, 160); doc.setFont('helvetica', 'normal');
  doc.text(`SRG Real Estate Pvt. Ltd. | Generated: ${dateStr()}`, 14, 290);
  doc.save(`SRG_Complete_Inventory_${dateStr().replace(/ /g, '-')}.pdf`);
}

export function generateWhatsAppMessage(project, plots) {
  const available = plots.filter(p => p.status === 'available');
  const d = dateStr();
  let msg = `🏢 *SRG Real Estate Pvt. Ltd.*\n📍 *${project.name}*\n_${project.type}_\n📅 ${d}\n\n`;
  msg += `📊 *Inventory Summary:*\n✅ Available: *${available.length}*\n🔴 Booked: *${plots.filter(p => p.status === 'booked').length}*\n📦 Total Plots: *${plots.length}*\n\n`;
  if (available.length > 0) {
    msg += `🔵 *Available Plots:*\n`;
    available.forEach((pl, i) => {
      msg += `${i + 1}. *Plot ${pl.plot_no}* | ${pl.facing || '—'} Facing | ${pl.size || '—'}\n`;
    });
  } else {
    msg += `❌ *Is project mein abhi koi plot available nahi hai.*\n`;
  }
  if (project.map_lat && project.map_lng) {
    msg += `\n📍 Location: https://maps.google.com/?q=${project.map_lat},${project.map_lng}`;
  }
  msg += `\n\n📞 *${project.contact}*\n🏢 _Gangaram Tower, Muhana Mandi Road Keshyawala, Gate No-1, Sanganer, Jaipur 302029_\n⚠️ _Hold sirf 24 ghante ke liye — uske baad release ho jaayega_`;
  return msg;
}
